import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { modifier } from 'ember-modifier';
import { or } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

const toggleModal = modifier(
  (element: HTMLDialogElement, [isOpen]: [boolean]) => {
    if (isOpen) {
      element.showModal();
    } else {
      element.close();
    }
  },
);

interface AlertSignature {
  Args: {
    description?: string;
    isOpen: boolean;
    onClose: (event: PointerEvent) => void;
    size?: 'base' | 'small';
    title?: string;
  };
  Blocks: {
    default: [];
  };
}

export default class UiAlertComponent extends Component<AlertSignature> {
  // Getter and setter
  get size() {
    return this.args.size ?? 'base';
  }

  // Template
  <template>
    {{#if @isOpen}}
      <dialog class={{bem (hash size=this.size)}} {{toggleModal @isOpen}}>
        <div class={{bem 'wrapper'}}>
          {{#if (or @title @description)}}
            <header class={{bem 'header'}}>
              <h2 class={{bem 'title'}}>{{@title}}</h2>
              <p class={{bem 'description'}}>
                {{@description}}
              </p>
            </header>
          {{/if}}

          <Button
            class={{bem 'close'}}
            @style='outline'
            @icon='close'
            {{on 'click' @onClose}}
          />

          <div class={{bem 'scroller'}}>
            <div class={{bem 'content'}}>
              {{yield}}
            </div>
          </div>
        </div>
      </dialog>
    {{/if}}
  </template>
}
